//The contents of this file have been generated automatically. Do not edit this file.

import { z } from 'zod';


export const ParamsTypeZOD = z.object({
    requestBody: z.object({
        bets: z.array(z.object({
            affiliate: z.string().nullish(),
            antePost: z.boolean().nullish(),
            channel: z.string(),
            correlationId: z.string().nullish(),
            country: z.object({
                value: z.string(),
            }).nullish(),
            currency: z.string().nullish(),
            eachWay: z.boolean(),
            freebetCredits: z.array(z.object({
                amount: z.string(),
                id: z.number(),
            })).nullish(),
            ip: z.string().nullish(),
            legs: z.array(z.union([z.object({
                eachWayTerms: z.object({
                    places: z.number(),
                    reduction: z.string(),
                }).nullish(),
                event: z.object({
                    name: z.string(),
                }),
                eventCountry: z.array(z.string()).nullish(),
                market: z.object({
                    type: z.string(),
                }).nullish(),
                price: z.object({
                    d: z.number(),
                    f: z.string(),
                }).nullish(),
                priceType: z.union([z.literal('ep') , z.literal('bp') , z.literal('fp') , z.literal('sp')]),
                selection: z.object({
                    name: z.string(),
                }),
                sportReference: z.object({
                    id: z.string(),
                }).nullish(),
                termsWithBet: z.boolean().nullish(),
                type: z.literal('empty'),
            }) , z.object({
                event: z.object({
                    externalId: z.string(),
                    id: z.number(),
                }),
                price: z.object({
                    d: z.number(),
                    f: z.string(),
                }).nullish(),
                priceType: z.union([z.literal('ep') , z.literal('bp') , z.literal('fp') , z.literal('sp')]),
                selections: z.unknown(),
                sport: z.object({
                    id: z.string(),
                }),
                type: z.literal('rab'),
            }) , z.object({
                event: z.object({
                    id: z.number(),
                }),
                market: z.object({
                    id: z.number(),
                }),
                price: z.object({
                    d: z.number(),
                    f: z.string(),
                }).nullish(),
                priceType: z.union([z.literal('ep') , z.literal('bp') , z.literal('fp') , z.literal('sp')]),
                selection: z.object({
                    id: z.number(),
                }),
                type: z.literal('standard'),
                uuid: z.string().nullish(),
            })])),
            remarks: z.array(z.object({
                code: z.string(),
                debugDetails: z.string().nullish(),
                details: z.union([z.object({
                    available: z.string(),
                    freebetCreditId: z.number(),
                    required: z.string(),
                    type: z.literal('available-amount-in-bonus-credit-too-small'),
                }) , z.object({
                    message: z.string(),
                    type: z.literal('could-not-calculate-bet-price'),
                }) , z.object({
                    creditIds: z.string(),
                    type: z.literal('invalid-credits'),
                }) , z.object({
                    available: z.string(),
                    required: z.string(),
                    type: z.literal('minimum-available-amount-in-wallet'),
                }) , z.object({
                    minimum: z.number(),
                    pots: z.array(z.number()),
                    type: z.literal('price-too-small'),
                }) , z.object({
                    provided: z.string(),
                    required: z.string(),
                    type: z.literal('total-credits-smaller-than-total-stake'),
                })]).nullish(),
                field: z.string().nullish(),
                pointer: z.string().nullish(),
                resource: z.string(),
            })).nullish(),
            stakePerLine: z.string(),
            type: z.union([z.literal('SGL') , z.literal('TTW') , z.literal('TTP') , z.literal('RAB') , z.literal('DBL') , z.literal('FC') , z.literal('RFC') , z.literal('SSA') , z.literal('TTE') , z.literal('TTRE') , z.literal('TBL') , z.literal('2F3') , z.literal('TRX') , z.literal('PAT') , z.literal('RR') , z.literal('TC') , z.literal('CFC') , z.literal('CTC') , z.literal('TTT') , z.literal('TTCE') , z.literal('TTCT') , z.literal('4F') , z.literal('2F4') , z.literal('3F4') , z.literal('YAN') , z.literal('L15') , z.literal('FLG') , z.literal('TTQ') , z.literal('5F') , z.literal('2F5') , z.literal('3F5') , z.literal('4F5') , z.literal('L31') , z.literal('CAN') , z.literal('SFLG') , z.literal('6F') , z.literal('2F6') , z.literal('3F6') , z.literal('4F6') , z.literal('5F6') , z.literal('HNZ') , z.literal('L63') , z.literal('TTPP') , z.literal('TTJP') , z.literal('TTS6') , z.literal('7F') , z.literal('2F7') , z.literal('3F7') , z.literal('4F7') , z.literal('5F7') , z.literal('6F7') , z.literal('SHNZ') , z.literal('8F') , z.literal('2F8') , z.literal('3F8') , z.literal('4F8') , z.literal('5F8') , z.literal('6F8') , z.literal('7F8') , z.literal('GOL') , z.literal('9F') , z.literal('2F9') , z.literal('3F9') , z.literal('8F9') , z.literal('10F') , z.literal('2F10') , z.literal('3F10') , z.literal('9F10') , z.literal('11F') , z.literal('2F11') , z.literal('3F11') , z.literal('10F11') , z.literal('12F') , z.literal('2F12') , z.literal('3F12') , z.literal('11F12') , z.literal('13F') , z.literal('2F13') , z.literal('3F13') , z.literal('12F13') , z.literal('14F') , z.literal('2F14') , z.literal('3F14') , z.literal('13F14') , z.literal('15F') , z.literal('2F15') , z.literal('3F15') , z.literal('14F15') , z.literal('16F') , z.literal('2F16') , z.literal('3F16') , z.literal('15F16') , z.literal('17F') , z.literal('2F17') , z.literal('3F17') , z.literal('16F17') , z.literal('18F') , z.literal('2F18') , z.literal('3F18') , z.literal('17F18') , z.literal('19F') , z.literal('2F19') , z.literal('3F19') , z.literal('18F19') , z.literal('20F') , z.literal('2F20') , z.literal('3F20') , z.literal('19F20') , z.literal('21F') , z.literal('2F21') , z.literal('3F21') , z.literal('20F21') , z.literal('22F') , z.literal('2F22') , z.literal('3F22') , z.literal('21F22') , z.literal('23F') , z.literal('2F23') , z.literal('3F23') , z.literal('22F23') , z.literal('24F') , z.literal('2F24') , z.literal('3F24') , z.literal('23F24') , z.literal('25F') , z.literal('2F25') , z.literal('3F25') , z.literal('24F25')]),
        })),
        ignoreProblems: z.array(z.object({
            code: z.string(),
            debugDetails: z.string().nullish(),
            details: z.unknown(),
            field: z.string().nullish(),
            pointer: z.string().nullish(),
            resource: z.string(),
        })).nullish(),
    }),
});
export type ParamsType = z.TypeOf<typeof ParamsTypeZOD>;


const checkResponse = <A>(code: number, decoder: z.ZodType<A>, data: unknown): A => {
    const decodeResult = decoder.safeParse(data);
    if (decodeResult.success) {
        return decodeResult.data;
    }
    throw Error(`Response decoding error /v1/bets -> post -> ${code}`);
};


export const Response201ZOD = z.object({
    data: z.object({
        bets: z.array(z.object({
            freebetCredits: z.array(z.any()).nullable().optional(),
            account: z.object({
                id: z.number(),
                name: z.string(),
                type: z.union([z.literal('customer'), z.literal('staff'), z.literal('program'), z.literal('anonymous')]),
            }),
            affiliate: z.string().nullable().optional(),
            cashOut: z.boolean(),
            channel: z.string(),
            comment: z.string().nullable().optional(),
            country: z.string().nullable().optional(),
            currency: z.string(),
            eachWay: z.boolean(),
            id: z.number().nullable().optional(),
            ip: z.string().nullable().optional(),
            legs: z.array(z.union([z.object({
                eachWayOffered: z.boolean(),
                eachWayTerms: z.object({
                    places: z.number(),
                    reduction: z.string(),
                }).nullable().optional(),
                event: z.object({
                    name: z.string(),
                }),
                eventCountry: z.array(z.string()),
                id: z.string(),
                inPlay: z.boolean(),
                market: z.object({
                    type: z.string(),
                }).nullable().optional(),
                price: z.object({
                    d: z.number(),
                    f: z.string(),
                }).nullable().optional(),
                priceType: z.union([z.literal('ep'), z.literal('bp'), z.literal('fp'), z.literal('sp')]),
                result: z.object({
                    dividends: z.object({
                        forecast: z.array(z.object({
                            '2nd': z.number(),
                            dividend: z.number(),
                            id: z.number(),
                            winner: z.number(),
                        })),
                        tricast: z.array(z.object({
                            '2nd': z.number(),
                            '3rd': z.number(),
                            dividend: z.number(),
                            id: z.number(),
                            winner: z.number(),
                        })),
                    }).nullable().optional(),
                    place: z.number().nullable().optional(),
                    placeReduction: z.string().nullable().optional(),
                    r4Deductions: z.number().nullable().optional(),
                    type: z.union([z.literal('won'), z.literal('lost'), z.literal('void'), z.literal('place'), z.literal('halfwon'), z.literal('halflost')]),
                    winReduction: z.string().nullable().optional(),
                }).nullable().optional(),
                selection: z.object({
                    name: z.string(),
                }),
                sport: z.object({
                    id: z.string(),
                }).nullable().optional(),
                termsWithBet: z.boolean().nullable().optional(),
                type: z.literal('empty'),
                uuid: z.string().nullable().optional(),
            }), z.object({
                competition: z.object({
                    id: z.string(),
                    name: z.string(),
                    url: z.string(),
                }).nullable().optional(),
                eachWayOffered: z.boolean(),
                eachWayTerms: z.object({
                    places: z.number(),
                    reduction: z.string(),
                }).nullable().optional(),
                event: z.object({
                    eventId: z.number().nullable().optional(),
                    name: z.string(),
                    platformEventId: z.string().nullable().optional(),
                    sport: z.string(),
                    status: z.union([z.literal('Prematch'), z.literal('Show'), z.literal('Started'), z.literal('Finished')]),
                }),
                id: z.string(),
                inPlay: z.boolean(),
                parameters: z.unknown(),
                price: z.object({
                    d: z.number(),
                    f: z.string(),
                }).nullable().optional(),
                priceType: z.union([z.literal('ep'), z.literal('bp'), z.literal('fp'), z.literal('sp')]),
                result: z.object({
                    dividends: z.object({
                        forecast: z.array(z.object({
                            '2nd': z.number(),
                            dividend: z.number(),
                            id: z.number(),
                            winner: z.number(),
                        })),
                        tricast: z.array(z.object({
                            '2nd': z.number(),
                            '3rd': z.number(),
                            dividend: z.number(),
                            id: z.number(),
                            winner: z.number(),
                        })),
                    }).nullable().optional(),
                    place: z.number().nullable().optional(),
                    placeReduction: z.string().nullable().optional(),
                    r4Deductions: z.number().nullable().optional(),
                    type: z.union([z.literal('won'), z.literal('lost'), z.literal('void'), z.literal('place'), z.literal('halfwon'), z.literal('halflost')]),
                    winReduction: z.string().nullable().optional(),
                }).nullable().optional(),
                selections: z.unknown(),
                sport: z.object({
                    id: z.string(),
                    name: z.string(),
                    url: z.string(),
                }).nullable().optional(),
                termsWithBet: z.boolean().nullable().optional(),
                type: z.literal('rab'),
                uuid: z.string().nullable().optional(),
            }), z.object({
                competition: z.object({
                    id: z.string(),
                    name: z.string(),
                    url: z.string(),
                }),
                eachWayOffered: z.boolean(),
                eachWayTerms: z.object({
                    places: z.number(),
                    reduction: z.string(),
                }).nullable().optional(),
                event: z.object({
                    id: z.string(),
                    idv2: z.string().nullable().optional(),
                    name: z.string(),
                    url: z.string(),
                }),
                eventCountry: z.array(z.string()),
                id: z.string(),
                inPlay: z.boolean(),
                market: z.object({
                    id: z.number(),
                    idv2: z.string().nullable().optional(),
                    name: z.string(),
                    url: z.string(),
                }),
                price: z.object({
                    d: z.number(),
                    f: z.string(),
                }).nullable().optional(),
                priceType: z.union([z.literal('ep'), z.literal('bp'), z.literal('fp'), z.literal('sp')]),
                result: z.object({
                    dividends: z.object({
                        forecast: z.array(z.object({
                            '2nd': z.number(),
                            dividend: z.number(),
                            id: z.number(),
                            winner: z.number(),
                        })),
                        tricast: z.array(z.object({
                            '2nd': z.number(),
                            '3rd': z.number(),
                            dividend: z.number(),
                            id: z.number(),
                            winner: z.number(),
                        })),
                    }).nullable().optional(),
                    place: z.number().nullable().optional(),
                    placeReduction: z.string().nullable().optional(),
                    r4Deductions: z.number().nullable().optional(),
                    type: z.union([z.literal('won'), z.literal('lost'), z.literal('void'), z.literal('place'), z.literal('halfwon'), z.literal('halflost')]),
                    winReduction: z.string().nullable().optional(),
                }).nullable().optional(),
                selection: z.object({
                    id: z.number(),
                    idv2: z.string().nullable().optional(),
                    name: z.string(),
                }),
                spPrice: z.object({
                    d: z.number(),
                    f: z.string(),
                }).nullable().optional(),
                sport: z.object({
                    id: z.string(),
                    name: z.string(),
                    url: z.string(),
                }),
                termsWithBet: z.boolean().nullable().optional(),
                type: z.literal('standard'),
                uuid: z.string().nullable().optional(),
            })])),
            maxBet: z.string().nullable().optional(),
            numLines: z.number(),
            operatorPayout: z.string().nullable().optional(),
            operatorProfit: z.string().nullable().optional(),
            operatorStakePerLine: z.string(),
            operatorTotalStake: z.string(),
            payout: z.string().nullable().optional(),
            placedAt: z.string(),
            placedBy: z.object({
                id: z.number(),
                name: z.string(),
                type: z.union([z.literal('customer'), z.literal('staff'), z.literal('program'), z.literal('anonymous')]),
            }).nullable().optional(),
            potentialReturns: z.string().nullable().optional(),
            profit: z.string().nullable().optional(),
            remarks: z.array(z.object({
                code: z.string(),
                debugDetails: z.string().nullable().optional(),
                details: z.unknown(),
                field: z.string().nullable().optional(),
                pointer: z.string().nullable().optional(),
                resource: z.string(),
            })),
            settledAt: z.string().nullable().optional(),
            settledBy: z.object({
                id: z.number(),
                name: z.string(),
                type: z.union([z.literal('customer'), z.literal('staff'), z.literal('program'), z.literal('anonymous')]),
            }).nullable().optional(),
            stakeFactor: z.number(),
            stakePerLine: z.string(),
            status: z.union([z.literal('open'), z.literal('parked'), z.literal('settled'), z.literal('cancelled'), z.literal('unsettled'), z.literal('rejected'), z.literal('initiated')]),
            totalStake: z.string(),
            transaction: z.object({
                assetFlows: z.array(z.object({
                    balanceDelta: z.number(),
                    currency: z.string(),
                    date: z.string().nullable().optional(),
                    details: z.unknown(),
                    externalId: z.string().nullable().optional(),
                    id: z.number().nullable().optional(),
                    type: z.string(),
                })),
                preconditions: z.array(z.object({
                    type: z.union([z.literal('withdrawableAtLeast'), z.literal('playableAtLeast'), z.literal('rejectFinalizedTransaction')]),
                    value: z.number().nullable().optional(),
                })),
                tags: z.object({
                    bonuses: z.array(z.object({
                        amount: z.number(),
                        id: z.number(),
                        type: z.string(),
                    })),
                    freebetCredits: z.array(z.object({
                        amount: z.number(),
                        id: z.number(),
                    })),
                    rabMetadata: z.object({
                        eventId: z.string(),
                    }).nullable().optional(),
                    selections: z.array(z.number()),
                }).nullable().optional(),
                updatedAt: z.string(),
                wallet: z.object({
                    account: z.object({
                        id: z.number(),
                        name: z.string(),
                        type: z.union([z.literal('customer'), z.literal('staff'), z.literal('program'), z.literal('anonymous')]),
                    }),
                    id: z.string(),
                }),
            }).nullable().optional(),
            type: z.union([z.literal('SGL'), z.literal('TTW'), z.literal('TTP'), z.literal('RAB'), z.literal('DBL'), z.literal('FC'), z.literal('RFC'), z.literal('SSA'), z.literal('TTE'), z.literal('TTRE'), z.literal('TBL'), z.literal('2F3'), z.literal('TRX'), z.literal('PAT'), z.literal('RR'), z.literal('TC'), z.literal('CFC'), z.literal('CTC'), z.literal('TTT'), z.literal('TTCE'), z.literal('TTCT'), z.literal('4F'), z.literal('2F4'), z.literal('3F4'), z.literal('YAN'), z.literal('L15'), z.literal('FLG'), z.literal('TTQ'), z.literal('5F'), z.literal('2F5'), z.literal('3F5'), z.literal('4F5'), z.literal('L31'), z.literal('CAN'), z.literal('SFLG'), z.literal('6F'), z.literal('2F6'), z.literal('3F6'), z.literal('4F6'), z.literal('5F6'), z.literal('HNZ'), z.literal('L63'), z.literal('TTPP'), z.literal('TTJP'), z.literal('TTS6'), z.literal('7F'), z.literal('2F7'), z.literal('3F7'), z.literal('4F7'), z.literal('5F7'), z.literal('6F7'), z.literal('SHNZ'), z.literal('8F'), z.literal('2F8'), z.literal('3F8'), z.literal('4F8'), z.literal('5F8'), z.literal('6F8'), z.literal('7F8'), z.literal('GOL'), z.literal('9F'), z.literal('2F9'), z.literal('3F9'), z.literal('8F9'), z.literal('10F'), z.literal('2F10'), z.literal('3F10'), z.literal('9F10'), z.literal('11F'), z.literal('2F11'), z.literal('3F11'), z.literal('10F11'), z.literal('12F'), z.literal('2F12'), z.literal('3F12'), z.literal('11F12'), z.literal('13F'), z.literal('2F13'), z.literal('3F13'), z.literal('12F13'), z.literal('14F'), z.literal('2F14'), z.literal('3F14'), z.literal('13F14'), z.literal('15F'), z.literal('2F15'), z.literal('3F15'), z.literal('14F15'), z.literal('16F'), z.literal('2F16'), z.literal('3F16'), z.literal('15F16'), z.literal('17F'), z.literal('2F17'), z.literal('3F17'), z.literal('16F17'), z.literal('18F'), z.literal('2F18'), z.literal('3F18'), z.literal('17F18'), z.literal('19F'), z.literal('2F19'), z.literal('3F19'), z.literal('18F19'), z.literal('20F'), z.literal('2F20'), z.literal('3F20'), z.literal('19F20'), z.literal('21F'), z.literal('2F21'), z.literal('3F21'), z.literal('20F21'), z.literal('22F'), z.literal('2F22'), z.literal('3F22'), z.literal('21F22'), z.literal('23F'), z.literal('2F23'), z.literal('3F23'), z.literal('22F23'), z.literal('24F'), z.literal('2F24'), z.literal('3F24'), z.literal('23F24'), z.literal('25F'), z.literal('2F25'), z.literal('3F25'), z.literal('24F25')]),
        })),
    }),
});
export type Response201Type = z.TypeOf<typeof Response201ZOD>;

export const Response400ZOD = z.object({
    error: z.object({
        code: z.union([z.literal('already-exists'), z.literal('validation-error')]),
        message: z.string(),
    }),
});
export type Response400Type = z.TypeOf<typeof Response400ZOD>;

export const Response401ZOD = z.object({
    error: z.object({
        code: z.literal('unauthorized'),
        message: z.string(),
    }),
});
export type Response401Type = z.TypeOf<typeof Response401ZOD>;

export const Response403ZOD = z.object({
    error: z.object({
        code: z.literal('forbidden'),
        message: z.string(),
    }),
});
export type Response403Type = z.TypeOf<typeof Response403ZOD>;

export const Response422ZOD = z.object({
    code: z.string(),
    debugDetails: z.string().nullable().optional(),
    details: z.unknown(),
    errors: z.array(z.object({
        code: z.string(),
        debugDetails: z.string().nullable().optional(),
        details: z.unknown(),
        field: z.string().nullable().optional(),
        pointer: z.string().nullable().optional(),
        resource: z.string(),
    })).nullable().optional(),
    message: z.string(),
});
export type Response422Type = z.TypeOf<typeof Response422ZOD>;

export const Response500ZOD = z.object({
    error: z.object({
        code: z.literal('internal-server-error'),
        message: z.string(),
    }),
});
export type Response500Type = z.TypeOf<typeof Response500ZOD>;



type ExtraHeadersType = Record<string, unknown> & {
    traceparent?: null | undefined | string;
    tracestate?: null | undefined | string;
};



export type OpenapiBettingPlaceBetParamsType = ParamsType;

export type OpenapiBettingPlaceBetResponseType = {
    status: 201;
    body: Response201Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 403;
    body: Response403Type;
} | {
    status: 422;
    body: Response422Type;
} | {
    status: 500;
    body: Response500Type;
};

const convertHeaders = (params: Record<string, string | null | undefined>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [name, value] of Object.entries(params)) {
        if (value !== null && value !== undefined) {
            result[name] = value;
        }
    }

    return result;
};

export const openapiBettingPlaceBetRequest = async (api_url: string, params: ParamsType, extraHeaders: ExtraHeadersType): Promise<OpenapiBettingPlaceBetResponseType> => {

    const ok = ParamsTypeZOD.safeParse(params);
    if (!ok.success) {
        console.error('Input parameters do not match the definition from openapi');
    }

    
        
    const query = '';
    const url = `${api_url}/v1/bets${query}`;
    

    const headers = convertHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        ...extraHeaders
    });

    const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(params.requestBody),
        credentials: 'include'
    });

    const status = response.status;

    let json = null;

    try {
        const text = await response.text();
        if (text !== '') {
            json = JSON.parse(text);
        }
    } catch (_err) {
        throw Error(`Http status ${status} - json was expected`);
    }
    
    if (status === 201) {
        return { status: 201, body: checkResponse(201, Response201ZOD, json) };
    }

    if (status === 400) {
        return { status: 400, body: checkResponse(400, Response400ZOD, json) };
    }

    if (status === 401) {
        return { status: 401, body: checkResponse(401, Response401ZOD, json) };
    }

    if (status === 403) {
        return { status: 403, body: checkResponse(403, Response403ZOD, json) };
    }

    if (status === 422) {
        return { status: 422, body: checkResponse(422, Response422ZOD, json) };
    }

    if (status === 500) {
        return { status: 500, body: checkResponse(500, Response500ZOD, json) };
    }

    throw new Error(`openapiBettingPlaceBetRequest - unhandled response ${status}`);
};

